import { IconButton, Box, SxProps } from "@mui/material";
import Image from "next/image";
import React, { useState } from "react";
import { useLingui } from "@lingui/react";
import AlertComponent from "@/components/core/alert";
import { t } from "@lingui/macro";
interface CustomAdornmentInputProps {
  placeholder: string;
  label?: string;
  value?: string; // New optional value prop
  sx?: SxProps;
}
export default function CustomAdornmentInput({
  placeholder,
  label,
  value,
  sx,
}: CustomAdornmentInputProps) {
  const { i18n } = useLingui();
  const [alert, setAlert] = useState<{
    text: string;
    severity: "success" | "error" | "warning" | "info";
  } | null>(null);
  const handleCopyToClipboard = () => {
    const textToCopy = value || placeholder; // Prioritize value over placeholder
    if (textToCopy) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setAlert({
            text: t(i18n)`Copied to clipboard!`,
            severity: "success",
          });
        })
        .catch((err) => {
          setAlert({
            text: t(i18n)`Failed to copy!`,
            severity: "error",
          });
          console.error("Failed to copy: ", err);
        });
    } else {
      setAlert({
        text: t(i18n)`Nothing to copy!`,
        severity: "warning",
      });
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "solid 2px",
          borderColor: "#0096aa",
          borderRadius: "8px",
          padding: "10px 12px",
          fontWeight: "bold",
          minWidth: "230px",
          ...(sx || {}),
        }}
      >
        {label && (
          <span className="mr-2 w-auto text-[15px] tracking-[1px] text-black">{label}</span>
        )}
        <span
          data-testid="copy-textfield"
          style={{
            cursor: "pointer",
            overflow: "hidden",
            textOverflow: "ellipsis",
            letterSpacing: "1px",
            fontSize: "15px",
            flex: 1,
          }}
          onClick={handleCopyToClipboard}
        >
          {placeholder}
        </span>
        <IconButton
          disableRipple
          aria-label="toggle custom adornment"
          edge="end"
          onClick={handleCopyToClipboard}
          sx={{ padding: "0px", marginLeft: "5px", mr: "2px" }}
        >
          <Image src="/clipboard.svg" alt="Clipboard" width={14} height={14} className="m-2" />
        </IconButton>
      </Box>
      {alert && <AlertComponent message={alert} setMessage={() => setAlert(null)} />}
    </Box>
  );
}
